module.exports = __webpack_public_path__ + "img/40.4daece6b.jpg";